<template>
  <div v-if="!isLoading" class="learning">
    <div v-if="isContentAvailable" class="learning__container">
      <h2 class="dashboard__tab-title">My Learning</h2>
      <ActiveCourses :isLoading="isLoading" />
      <Bookmarks
        id="bookmarks"
        ref="bookmarks"
        :isLoading="isLoading"
        @bookmarks-loaded="isBookmarksSectionLoaded()"
      />
    </div>
    <div v-else class="learning__container">
      <img
        class="learning__empty-img"
        src="@/assets/images/profile/empty_state_bookmarks.png"
      />
      <div class="dashboard__tab-title learning__title">
        You don’t have any active courses or saved Bookmarks yet.
      </div>
      <div class="learning__info">
        You can find your in-progress courses and bookmarks here.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActiveCourses from '@/components/user-dashboard/learning/ActiveCourses.vue'
import Bookmarks from '@/components/user-dashboard/learning/Bookmarks.vue'

export default {
  name: 'Learning',
  components: {
    ActiveCourses,
    Bookmarks,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      bookmarksSectionLoaded: false,
    }
  },
  watch: {
    bookmarksSectionLoaded() {
      this.handleAnchorScroll()
    },
  },
  computed: {
    ...mapState({
      rawBookmarks: state => state.content.currentBookmarks,
      activeCourses: state => state.courses.activeCourses,
    }),
    isContentAvailable() {
      return this.rawBookmarks?.length || this.activeCourses?.length
    },
  },
  methods: {
    isBookmarksSectionLoaded(state) {
      this.bookmarksSectionLoaded = state
    },
    handleAnchorScroll() {
      if (!this.isContentAvailable) return
      if (this.$route.params?.section === 'bookmarks') {
        this.$nextTick(() => {
          if (this.rawBookmarks?.length) {
            const element = document.getElementById('bookmarks')
            const headerOffset = 100
            const elementPosition = element.getBoundingClientRect().top
            const offsetPosition =
              elementPosition + window.pageYOffset - headerOffset
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            })
          }
        })
      }
    },
  },
  async created() {
    await this.$store.dispatch('content/getBookmarks')
    await this.$store.dispatch('courses/getActiveCourses')
    this.$store.dispatch('app/setIsComponentLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.learning {
  &__title {
    text-align: center;
    margin: 0 0 10px 0;
  }
  &__info {
    text-align: center;
    font-size: rem(16);
    line-height: 24px;
    color: var(--light-blue-gray);
  }
  &__empty-img {
    margin: auto;
    width: 100%;
    max-height: 315px;
    object-fit: contain;
  }
}
</style>
